import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.less';

const propTypes = {
  style: PropTypes.shape({
    top: PropTypes.string,
  }),
  onClick: PropTypes.func,
  img: PropTypes.string,
  text: PropTypes.string,
};
const defaultProps = {
  style: {},
  onClick: () => {},
  img: '',
  text: '',
};

class SuspendButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oLeft: '',
      oTop: '',
    };
    this.$vm = null; // 悬浮按钮
    this.moving = false; // 移动状态

    this.oW = null; // 悬钮距离
    this.oH = null;

    this.htmlWidth = null; // 页面宽度
    this.htmlHeight = null;

    this.bWidth = null; // 悬钮宽度
    this.bHeight = null;

    this.click = false; // 是否是点击
  }

  componentDidMount() {
    const { style } = this.props;
    this.$vm.addEventListener(
      'touchmove',
      (e) => {
        if (e.cancelable) {
          e.preventDefault();
        }
      },
      {
        passive: false,
      },
    );
    this.setState({ oTop: Number(style.top.replace('px', '')) });
  }

  // 移动触发
  onTouchStart(e1) {
    const [e] = e1.touches;
    this.click = true;

    this.oW = e.clientX - this.$vm.getBoundingClientRect().left;
    this.oH = e.clientY - this.$vm.getBoundingClientRect().top;

    this.htmlWidth = document.documentElement.clientWidth;
    this.htmlHeight = document.documentElement.clientHeight;

    this.bWidth = this.$vm.offsetWidth;
    this.bHeight = this.$vm.offsetHeight;

    const oLeft = e.clientX - this.oW;
    const oTop = e.clientY - this.oH;
    this.setState({
      oLeft,
      oTop,
    });

    this.moving = true;
  }

  // 移动结束
  onTouchEnd() {
    const { onClick } = this.props;
    this.moving = false;

    this.$vm.className = `${this.$vm.className} ${styles.tSuspendButton}`;

    // 左侧距离
    let { oLeft } = this.state;
    let { oTop } = this.state;
    if (oLeft < (this.htmlWidth - this.bWidth) / 2) {
      oLeft = 10;
    } else {
      oLeft = this.htmlWidth - this.bWidth - 10;
    }

    if (this.click) {
      onClick();
    }
    if (oTop < 0) {
      oTop = 0;
    } else if (oTop < 250) {
      oTop = 250;
    }

    this.setState({
      oLeft,
      oTop,
    });
  }

  // 开始移动
  onTouchMove(e) {
    this.$vm.className = styles.tSuspendButton;
    if (this.moving) this.onMove(e);
  }

  // 移动中
  onMove(e1) {
    const [e] = e1.touches;
    this.click = false;

    // 左侧距离
    let oLeft = e.clientX - this.oW;
    let oTop = e.clientY - this.oH;
    if (oLeft < 0) {
      oLeft = 0;
    } else if (oLeft > this.htmlWidth - this.bWidth) {
      oLeft = this.htmlWidth - this.bWidth;
    }
    if (oTop < 0) {
      oTop = 0;
    } else if (oTop > this.htmlHeight - this.bHeight) {
      oTop = this.htmlHeight - this.bHeight;
    }

    this.setState({
      oLeft,
      oTop,
    });
  }

  render() {
    const { img, text } = this.props;
    const { oLeft, oTop } = this.state;
    return (
      <div
        className={styles.tSuspendButton}
        ref={($vm) => { this.$vm = $vm; }}
        onTouchStart={(e) => this.onTouchStart(e)}
        onTouchMove={(e) => this.onTouchMove(e)}
        onTouchEnd={(e) => this.onTouchEnd(e)}
        style={{
          left: `${oLeft}px`,
          top: `${oTop}px`,
        }}
      >
        <div style={{ position: 'relative' }}>
          {img && <img src={img} alt="" />}
          <span className={styles.person}>
            {text || ''}
          </span>
        </div>

      </div>
    );
  }
}

SuspendButton.propTypes = propTypes;
SuspendButton.defaultProps = defaultProps;

export default SuspendButton;
